import createPersistedState from 'vuex-persistedstate'

export default createPersistedState({
    key: process.env.VUE_APP_VUEX_KEY,
    storage: window.sessionStorage,
    paths: [
        'app',
        'auth',
        'usuario',
    ]
})